// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createKnowledgeBaseGrantRequestToJson, createKnowledgeBaseGrantResponseFromJson, listKnowledgeBaseGrantDependentsRequestToJson, listKnowledgeBaseGrantDependentsResponseFromJson, listKnowledgeBaseGrantsForKnowledgeBaseRequestToJson, listKnowledgeBaseGrantsForKnowledgeBaseResponseFromJson, listKnowledgeBaseGrantsForNamespaceRequestToJson, listKnowledgeBaseGrantsForNamespaceResponseFromJson, revokeKnowledgeBaseGrantsRequestToJson, revokeKnowledgeBaseGrantsResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createKnowledgeBaseGrant(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseGrantService/CreateKnowledgeBaseGrant', createKnowledgeBaseGrantRequestToJson(request));
    return createKnowledgeBaseGrantResponseFromJson(raw);
}
export function createKnowledgeBaseGrant$(request, options) {
    return defer(() => createKnowledgeBaseGrantWithTransport$(getGlobalTransport(), request, options));
}
export function createKnowledgeBaseGrantWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseGrantService/CreateKnowledgeBaseGrant', createKnowledgeBaseGrantRequestToJson(request), options)
        .pipe(map(resp => createKnowledgeBaseGrantResponseFromJson(resp)));
}
export async function revokeKnowledgeBaseGrants(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseGrantService/RevokeKnowledgeBaseGrants', revokeKnowledgeBaseGrantsRequestToJson(request));
    return revokeKnowledgeBaseGrantsResponseFromJson(raw);
}
export function revokeKnowledgeBaseGrants$(request, options) {
    return defer(() => revokeKnowledgeBaseGrantsWithTransport$(getGlobalTransport(), request, options));
}
export function revokeKnowledgeBaseGrantsWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseGrantService/RevokeKnowledgeBaseGrants', revokeKnowledgeBaseGrantsRequestToJson(request), options)
        .pipe(map(resp => revokeKnowledgeBaseGrantsResponseFromJson(resp)));
}
export async function listKnowledgeBaseGrantDependents(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseGrantService/ListKnowledgeBaseGrantDependents', listKnowledgeBaseGrantDependentsRequestToJson(request));
    return listKnowledgeBaseGrantDependentsResponseFromJson(raw);
}
export function listKnowledgeBaseGrantDependents$(request, options) {
    return defer(() => listKnowledgeBaseGrantDependentsWithTransport$(getGlobalTransport(), request, options));
}
export function listKnowledgeBaseGrantDependentsWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseGrantService/ListKnowledgeBaseGrantDependents', listKnowledgeBaseGrantDependentsRequestToJson(request), options)
        .pipe(map(resp => listKnowledgeBaseGrantDependentsResponseFromJson(resp)));
}
export async function listKnowledgeBaseGrantsForKnowledgeBase(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseGrantService/ListKnowledgeBaseGrantsForKnowledgeBase', listKnowledgeBaseGrantsForKnowledgeBaseRequestToJson(request));
    return listKnowledgeBaseGrantsForKnowledgeBaseResponseFromJson(raw);
}
export function listKnowledgeBaseGrantsForKnowledgeBase$(request, options) {
    return defer(() => listKnowledgeBaseGrantsForKnowledgeBaseWithTransport$(getGlobalTransport(), request, options));
}
export function listKnowledgeBaseGrantsForKnowledgeBaseWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseGrantService/ListKnowledgeBaseGrantsForKnowledgeBase', listKnowledgeBaseGrantsForKnowledgeBaseRequestToJson(request), options)
        .pipe(map(resp => listKnowledgeBaseGrantsForKnowledgeBaseResponseFromJson(resp)));
}
export async function listKnowledgeBaseGrantsForNamespace(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseGrantService/ListKnowledgeBaseGrantsForNamespace', listKnowledgeBaseGrantsForNamespaceRequestToJson(request));
    return listKnowledgeBaseGrantsForNamespaceResponseFromJson(raw);
}
export function listKnowledgeBaseGrantsForNamespace$(request, options) {
    return defer(() => listKnowledgeBaseGrantsForNamespaceWithTransport$(getGlobalTransport(), request, options));
}
export function listKnowledgeBaseGrantsForNamespaceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseGrantService/ListKnowledgeBaseGrantsForNamespace', listKnowledgeBaseGrantsForNamespaceRequestToJson(request), options)
        .pipe(map(resp => listKnowledgeBaseGrantsForNamespaceResponseFromJson(resp)));
}
